import { FC, ReactElement } from 'react';
import styled from 'styled-components';
import QRCode from 'react-qr-code';
import BlockContainer from './BlockContainer';

interface BlockExternalLinkItemProps {
  url: string,
  title?: string
}

interface BlockExternalLinksWrapperProps {
  children: ReactElement | ReactElement[]
}

const BlockLinks = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

const BlockLink = styled.li`
  padding: 0;
  display: flex;
  align-items: flex-start;
  margin-bottom: 1.5vw;

  &:last-of-type {
    margin-bottom: 0;
  }

  & svg {
    width: 10vw;
    height: 10vw;
  }
`;

const Title = styled.span`
  font-weight: 600;
  padding: 1vw 2vw;
`;

/**
 * Render a PDF block container
 * @returns {JSX.Element} Component template
 */
export const BlockExternalLinksWrapper: FC<BlockExternalLinksWrapperProps> = ({children}) => {
  return (
    <BlockContainer>
      <BlockLinks>
        {children}
      </BlockLinks>
    </BlockContainer>
  )
}

/**
 * Render a link block
 * @returns {JSX.Element} Component template
 */
 export const BlockExternalLinkItem: FC<BlockExternalLinkItemProps> = ({url, title}) => {

  if (!url || url.length < 3) {
    return null;
  }

  return (
    <BlockLink>
      <QRCode value={url || ""} />
      {title && (<Title>{title}</Title>)}
    </BlockLink>
  );
}